<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">亲属添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="relativeForm" :rules="relativeRules" ref="relativeForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="亲属姓名" required prop="name">
                                    <el-input v-model="relativeForm.name" placeholder="请输入亲属姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="联系电话" required prop="phone">
                                    <el-input v-model="relativeForm.phone" maxlength="11" placeholder="请输入联系电话"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="与老人关系" required prop="relation">
                                    <el-select v-model="relativeForm.relation" placeholder="请选择与紧急联系人的关系" style="width:100%">
                                        <el-option
                                                v-for="item in elderlyAllType.relationship"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="工作单位" required prop="workUnit">
                                    <el-input v-model="relativeForm.workUnit" placeholder="请输入工作单位"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="地址" required prop="address">
                                    <el-input v-model="relativeForm.address" placeholder="请输入地址"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('relativeForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import elderly from "@/common/status";
    export default {
        name: 'Add',
        data() {
            return {

                loading: false,

                relativeForm:{
                    name:'',
                    phone:'',
                    relation:'',
                    workUnit:'',
                    address:'',
                },

                relativeRules:{
                    name:[{ required: true, message: '请输入亲属姓名', trigger: 'blur' },],
                    phone:[{ required: true, message: '请输入联系电话', trigger: 'blur' },{
                        pattern: /^1[3456789]\d{9}$/,
                        message: '请输入正确的手机号'
                    },],
                    relation:[{ required: true, message: '请选择与老人关系', trigger: 'blur' },],
                    workUnit:[{ required: true, message: '请输入工作单位', trigger: 'blur' },],
                    address:[{ required: true, message: '请输入地址', trigger: 'blur' },],
                },
                elderlyAllType:elderly

            }
        },

        methods: {
            init(){
                this.$refs.relativeForm.resetFields();
            },
            closeSelf() {
                this.$emit("close");
            },

            confirm(relativeForm){
                this.$refs[relativeForm].validate((valid) => {
                    if(valid){
                        this.$emit("relativeConfirm",this.relativeForm);
                        this.$emit("close");
                    }else {
                        return false;
                    }
                })

            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
